import { Partenaire } from '../../../shared/models/partenaire.model';
import { PartenaireService } from '../../../shared/services/partenaire.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-partenaire-new',
  templateUrl: './partenaire-new.component.html',
  styleUrls: ['./partenaire-new.component.css']
})
export class PartenaireNewComponent implements OnInit {

  user: Partenaire = new Partenaire();
  partenaireDetailsForm: FormGroup;

  constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder,
    private service: PartenaireService) {
    this.partenaireDetailsForm = this.formBuilder.group({
      'email': ['', Validators.required],
      'name': ['', Validators.required],
      'description': ['', Validators.required]
    });

  }

  ngOnInit() {
  }

  onUserDetailsSubmit(): void {
    (<any>Object).assign(this.user, this.partenaireDetailsForm.value);

    this.service.add(this.user)
      .subscribe(data => this.activeModal.close('user-modal-success'), err => console.log(err));
  }

}
